module.exports = "<cpwd></cpwd>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/changePassword/changePassword.html
// module id = 490
// module chunks = 0